import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative pt-8 pb-10 sm:pt-12 sm:pb-16 px-4 overflow-hidden flex flex-col justify-center" data-id="element-149">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: 'url("https://images.unsplash.com/photo-1533777857889-4be7c70b33f7?w=1600&q=80")'
    }} data-id="element-150">
        <div className="absolute inset-0 bg-black/60 backdrop-blur-[2px]" data-id="element-151"></div>
      </div>

      <div className="max-w-2xl mx-auto text-center relative z-10" data-id="element-152">
        {/* Tagline */}
        <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full mb-4 sm:mb-6" data-id="element-153">
          <span className="text-xs sm:text-sm font-bold tracking-wider text-white uppercase leading-tight" data-id="element-154">
            🍃 METODO MEDITERRANEO™
          </span>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.05
      }} className="text-2xl sm:text-4xl md:text-5xl font-serif font-bold text-white leading-[1.15] mb-4 sm:mb-6" data-id="element-155">
          Mangia Bene. Sentiti Leggero. Ritrova la Tua Energia.
        </motion.h1>

        {/* Subheadline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="text-sm sm:text-lg text-gray-200 leading-relaxed mb-5 sm:mb-8 max-w-xl mx-auto font-medium" data-id="element-156">
          Il sistema completo ispirato alla tradizione mediterranea per
          trasformare la tua alimentazione in modo semplice e sostenibile —
          senza diete, senza rinunce, senza stress.
        </motion.p>

        {/* Feature pills */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.15
      }} className="flex flex-wrap justify-center gap-1.5 sm:gap-3 mb-5 sm:mb-8" data-id="element-157">
          {['Oltre 300 ricette', 'Piani mensili', 'Meal Prep', 'Guida Anti-Gonfiore'].map((feature, i) => <span key={i} className="bg-brand-olive/80 backdrop-blur-sm text-white text-[10px] sm:text-sm font-semibold px-2.5 py-0.5 sm:px-3 sm:py-1 rounded-full" data-id="element-158">
              {feature}
            </span>)}
        </motion.div>

        {/* Product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="mb-5 sm:mb-8" data-id="element-159">
          <a href="#pricing" className="block cursor-pointer group" data-id="element-160">
            <img src="https://cdn.magicpatterns.com/uploads/xp8hWLP94c89qYGzRTZU3T/my-project-page-1_(11).png" alt="Metodo Mediterraneo Kit" className="w-full h-auto object-contain drop-shadow-2xl group-hover:scale-[1.02] transition-transform duration-500" data-id="element-161" />
          </a>
        </motion.div>

        {/* Star rating */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.25
      }} className="flex items-center justify-center gap-2 mb-3 sm:mb-4" data-id="element-162">
          <div className="flex" data-id="element-163">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-brand-gold fill-current" data-id="element-164" />)}
          </div>
          <span className="text-xs sm:text-sm font-bold text-white" data-id="element-165">
            4.9/5 · +500 recensioni verificate
          </span>
        </motion.div>

        {/* Scarcity pill */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.3
      }} className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-md border border-white/20 px-3 py-1.5 sm:px-4 sm:py-2 rounded-full mb-4 sm:mb-6" data-id="element-166">
          <span className="text-xs sm:text-sm font-bold text-white" data-id="element-167">
            🔥 1.500+ persone stanno già trasformando la loro alimentazione
          </span>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} data-id="element-168">
          <CTAButton className="w-full sm:w-auto sm:min-w-[300px]" variant="primary" data-id="element-169">
            🚀 SÌ, VOGLIO INIZIARE IL MIO RESET MEDITERRANEO
          </CTAButton>
        </motion.div>

        {/* Trust line */}
        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-1 mt-4 sm:mt-6 text-[10px] sm:text-sm text-gray-300 font-medium" data-id="element-170">
          <span data-id="element-171">⚡ Accesso Immediato</span>
          <span className="text-gray-500" data-id="element-172">•</span>
          <span data-id="element-173">🛡️ Garanzia 7 Giorni</span>
          <span className="text-gray-500" data-id="element-174">•</span>
          <span data-id="element-175">💳 Pagamento Unico</span>
        </div>
      </div>
    </section>;
}